var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_764_1655",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_764_1655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4 12.3667C1.015 12.3667 0.685533 12.2297 0.4116 11.9558C0.1372 11.6814 0 11.3517 0 10.9667V2.56667C0 2.18167 0.1372 1.8522 0.4116 1.57827C0.685533 1.30387 1.015 1.16667 1.4 1.16667H12.6C12.985 1.16667 13.3147 1.30387 13.5891 1.57827C13.863 1.8522 14 2.18167 14 2.56667V10.9667C14 11.3517 13.863 11.6814 13.5891 11.9558C13.3147 12.2297 12.985 12.3667 12.6 12.3667H1.4ZM7 7.46667L1.4 3.96667V10.9667H12.6V3.96667L7 7.46667ZM7 6.06667L12.6 2.56667H1.4L7 6.06667ZM1.4 3.96667V2.56667V10.9667V3.96667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIc);
export default __webpack_public_path__ + "static/media/mail-ic.6d33807510c4108a4f7169570e5a1736.svg";
export { ForwardRef as ReactComponent };